<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="crm-interaction-detail-container">
    <div class="ecs-crm-additional-detail-info">
      <div class="grid px-4">
        <InteractionDetailDynamicField
          v-for="field in fieldsToDisplay"
          :key="field.id"
          :interaction-id="interaction.interactionId"
          :field-from-template="field"
          :interaction-variable="getVariableForField(field)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EcsSideBarInteractionItemMixin from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionItemMixin';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';
import EcsTimeFormatter from '@/mixins/ecs-time-formatter/EcsTimeFormatter';
import InteractionDetailDynamicField from '@/components/ecs-interaction/InteractionDetailDynamicField.vue';

export default {
  name: 'InteractionDetailCrm',

  components: { InteractionDetailDynamicField },

  mixins: [EcsKpiFormatter, EcsTimeFormatter, EcsSideBarInteractionItemMixin],

  props: {
    interaction: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      selectedInteractionTemplate: null,
      selectedInteractionDetailsDisplayTemplate: {},
      fieldsToDisplay: []
    };
  },

  computed: {
    ...mapGetters('ORGANIZATION', ['interactionDetailsDisplayTemplates', 'getInteractionDetailsDisplayTemplateForBP']),

    ...mapGetters('REFERENCES', ['valueSets']),

    template() {
      return this.getInteractionDetailsDisplayTemplateForBP(this.interaction.routing.businessProcessId);
    }
  },

  watch: {
    template: {
      handler() {
        this.selectedInteractionTemplate = this.template;
        this.selectedInteractionDetailsDisplayTemplate = this.template;
        this.setFieldsToDisplay();
      },
      immediate: true
    },
    selectedInteractionDetailsDisplayTemplate: {
      handler() {
        this.setFieldsToDisplay();
      }
    },
    immediate: true
  },

  created() {
    if (this.valueSets.length === 0) {
      this.requestValueSets();
    }
  },

  methods: {
    ...mapActions('REFERENCES', ['requestValueSets']),

    setFieldsToDisplay() {
      this.fieldsToDisplay = this.selectedInteractionDetailsDisplayTemplate.fields
        .sort((fieldA, fieldB) => fieldA.order - fieldB.order)
        .map(field => ({ id: (Math.random() * 1e7) | 0, ...field }));
    },

    getVariableForField(field) {
      return (this.interaction.interactionVariables || []).find(
        variable => variable.name === field.interactionVariableName
      );
    },

    onInteractionTemplateChange(event) {
      this.selectedInteractionDetailsDisplayTemplate = event;
    }
  }
};
</script>

<style scoped>
.crm-interaction-detail-container {
  height: 100%;
  overflow-y: auto;
}

.crm-interaction-detail-loading {
  padding: 16px;
  text-align: center;
  width: 100%;
  align-self: center;
  justify-self: center;
}

.crm-interaction-details {
  width: 100%;
  padding: 16px 32px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 0.8fr));
  grid-gap: 0 24px;
  justify-content: center;
}

.crm-no-interaction-detail-info {
  border-radius: 8px !important;
  border: 2px dashed rgba(0, 0, 0, 0.5);
  color: rgba(0, 0, 0, 0.5);
  padding: 16px;
  margin: 16px;
  text-align: center;
  width: calc(100% - 32px);
  align-self: center;
  justify-self: center;
}

[dark].crm-no-interaction-detail-info {
  border: 2px dashed rgba(255, 255, 255, 0.5);
  color: rgba(255, 255, 255, 0.5);
}

.crm-no-interaction-detail-info > div:not(:first-child) {
  margin-top: 16px;
}

.crm-interaction-detail-interaction-link {
  text-decoration: underline;
}

.action-btn {
  transition: all 0.2s ease;
  opacity: 0.5;
  margin-right: 4px;
}

.action-btn:hover {
  opacity: 1;
}

.ecs-crm-additional-detail-info {
  margin: 0 0 12px 0;
  border-radius: 4px;
}
.ecs-crm-additional-detail-info .grid {
  width: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 0.8fr));
  grid-gap: 0 24px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.ecs-crm-additional-detail-info .grid .field {
  padding: 4px 0 4px 8px;
  border-radius: 4px;
  display: grid;
  grid-template-columns: auto 48px;
  background-color: var(--v-surface-base);
}
.ecs-crm-additional-detail-info .grid .field:hover {
  background-color: var(--v-surface-darken1);
}
.ecs-crm-additional-detail-info .grid .field:hover .actions {
  opacity: 1;
}
.ecs-crm-additional-detail-info .grid .field .content .prop-label {
  opacity: 0.75;
  font-size: 12px;
  padding-right: 4px;
  min-width: 120px;
  display: inline-block;
}
.ecs-crm-additional-detail-info .grid .field .content .prop-value {
  font-size: 14px;
  font-weight: bold;
}
.ecs-crm-additional-detail-info .grid .field .actions {
  transition: all 0.2s linear;
  opacity: 0;
}
.ecs-crm-additional-detail-info .grid .field .actions button {
  margin: 0 4px;
  width: 42px;
  height: 42px;
}
</style>
